import { ReactNode } from "react";
import TableHead, { TableHeadProps } from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { createUseStyles } from "react-jss";

type Props = {
  children?: ReactNode;
} & TableHeadProps;

function Thead({ children, ...tableHeadProps }: Props) {
  const classes = useStyles();
  return (
    <TableHead className={classes.tableTitle} {...tableHeadProps}>
      <TableRow>{children}</TableRow>
    </TableHead>
  );
}

const useStyles = createUseStyles(() => ({
  tableTitle: {
    textTransform: "uppercase",
    background: "#F4F5F7 0% 0% no-repeat padding-box",
    borderRadius: "3px 3px 0px 0px",
    "& th": {
      color: "#7A869A",
      lineHeight: "16px",
      fontSize: 13,
      fontFamily: "Work Sans, sans-serif",
    },
    "& th, td": {
      minWidth: 125,
      lineHeight: "16px",
    },
  },
}));

export default Thead;
